import { BigNumber } from '@ethersproject/bignumber'
import { ContractPriceFeed } from 'modules/contracts/contracts'
import {
  getERCAssetAddress,
  PoolAsset,
} from 'modules/pools/constants/poolAssets'
import { Chains } from '../chains'

type Args = {
  assetA: PoolAsset
  assetB: PoolAsset | 'USD'
  assetAAmount?: number
  chainId: Chains
}

export const getAssetPairPrice = async ({
  assetA,
  assetB,
  assetAAmount = 1,
  chainId,
}: Args) => {
  const priceFeed = ContractPriceFeed.connectRpc({ chainId })

  const assetAAddress = getERCAssetAddress(assetA, chainId)
  const [assetAUSDPrice, decimals] = await priceFeed.getLatestPriceUSD(
    assetAAddress,
  )

  let assetBUSDPrice = BigNumber.from(1)

  if (assetB !== 'USD') {
    const assetBAddress = getERCAssetAddress(assetB, chainId)
    assetBUSDPrice = await priceFeed
      .getLatestPriceUSD(assetBAddress)
      .then(r => r[0])
  }

  return {
    price: assetBUSDPrice.isZero()
      ? BigNumber.from(0)
      : assetAUSDPrice.div(assetBUSDPrice).mul(assetAAmount),
    decimals,
  }
}
